export default "__VITE_ASSET__56c2f91b__"